import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {environment} from 'environments/environment';
import {Environment } from 'environments/environment.model';

@Injectable()
export class AppConfigEnvironmentService {
	env:Environment=environment;
    private _Environment: any;

    constructor(private http: HttpClient) {
    }

    public get Environment(): AppConfigEnvironment {
        return this._Environment;
    }


    public initialize(): Promise<any> {
        return this.http.get<AppConfigEnvironment>('/assets/data/appConfig.json')
            .pipe(
                tap(response => {
                    //this._Environment = response;
					let settingEnviroment={...this.env,...response};
                    Utilities.APPCONFIGENVIRONMENT = settingEnviroment;
					this._Environment = settingEnviroment;

                }),
                catchError(err => {
                    console.error(`Error in intialize app config: ${JSON.stringify(err)}`);
                    return throwError(err)
                })
            ).toPromise()
    }


}
